import { useLayoutEffect, useMemo, useRef, useState, } from 'react';
export function useIntersecting(options = {}) {
    // observe sentinel intersection
    const sentinelRef = useRef(null);
    const [isIntersecting, setIsIntersecting] = useState(false);
    const observerRef = useRef(typeof window !== 'undefined' // check for SSR
        ? new IntersectionObserver(([entry]) => {
            setIsIntersecting(entry.isIntersecting);
        }, options)
        : null);
    useLayoutEffect(() => {
        const observer = observerRef.current;
        !!sentinelRef.current && observer?.observe(sentinelRef.current);
        return () => {
            observer?.disconnect();
        };
    }, []);
    // memoize result
    const result = useMemo(() => ({
        isIntersecting,
        sentinelRef,
    }), [isIntersecting]);
    return result;
}
